import { render, staticRenderFns } from "./DFTable.vue?vue&type=template&id=dbd8ce9e&"
import script from "./DFTable.vue?vue&type=script&lang=js&"
export * from "./DFTable.vue?vue&type=script&lang=js&"
import style0 from "./DFTable.vue?vue&type=style&index=0&id=dbd8ce9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports